// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
  'use strict';

  // Focus input if Searchform is empty
  [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
    el.addEventListener('submit', function (e) {
      var search = el.querySelector('input');
      if (search.value.length < 1) {
        e.preventDefault();
        search.focus();
      }
    });
  });

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: 'focus',
    });
  });
})();

// ALLboards custom scripts - Vanilla JS welcome :)
const swiperHero = new Swiper('.swiper__hero', {
  loop: true,
  grabCursor: true,
  spaceBetween: 50,
  speed: 300,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },

  pagination: {
    el: '.swiper-pagination.hero-pagination',
    clickable: true,
  },
});

const swiperLogos = new Swiper('.swiper__customers-logos', {
  loop: true,
  loopedSlides: 99,
  freeMode: true,
  autoplay: {
    delay: 1,
    disableOnInteraction: false,
  },
  spaceBetween: 60,
  slidesPerView: 'auto',
  speed: 3000,
});

const swiperWhyAllboards = new Swiper('.swiper__why-allboards', {
  speed: 300,

  breakpoints: {
    0: {
      loop: true,
      grabCursor: true,
      slidesPerView: 1.2,
      spaceBetween: 16,
      centeredSlides: true,

      pagination: {
        el: '.swiper-pagination.why-allboards-pagination',
        type: 'bullets',
        clickable: true,
      },
    },

    576: {
      loop: true,
      centeredSlides: true,
      spaceBetween: 16,
      slidesPerView: 2.1,

      pagination: {
        el: '.swiper-pagination.why-allboards-pagination',
        type: 'bullets',
        clickable: true,
      },
    },

    992: {
      centeredSlides: false,
      slidesPerView: 4,
      spaceBetween: 32,
    },
  },
});

const swiperReviews = new Swiper('.swiper__reviews', {
  speed: 300,

  breakpoints: {
    0: {
      loop: true,
      grabCursor: true,
      slidesPerView: 1.2,
      spaceBetween: 16,
      centeredSlides: true,

      pagination: {
        el: '.swiper-pagination.reviews-pagination',
        type: 'bullets',
        clickable: true,
      },
    },

    576: {
      loop: true,
      centeredSlides: true,
      spaceBetween: 16,
      slidesPerView: 2.1,

      pagination: {
        el: '.swiper-pagination.reviews-pagination',
        type: 'bullets',
        clickable: true,
      },
    },

    992: {
      slidesPerView: 3,
      spaceBetween: 32,
      centeredSlides: false,
    },
  },
});

// Change navbar color when scolled
const headerElement = document.querySelector('#header');
const mainElement = document.querySelector('main');
const scrollTopElement = document.querySelector('#scroll-top');

document.addEventListener('scroll', () => {
  let rectNabvar = mainElement.getBoundingClientRect();

  if (rectNabvar.top === 0) {
    headerElement.classList.remove('scrolled');
  } else {
    headerElement.classList.add('scrolled');
  }

  if (rectNabvar.top < -200) {
    scrollTopElement.classList.add('visible');
  } else {
    scrollTopElement.classList.remove('visible');
  }
});

// Hide mobile menu after click on all items except for the last
const navbarElement = document.querySelector('#navbar');
const navbarToggler = document.querySelector('.navbar-toggler');
const navItems = document.querySelectorAll('.navbar-nav .nav-item');

navItems.forEach((item, index) => {
  if (navItems.length - 1 !== index) {
    item.addEventListener('click', () => {
      if (navbarElement.classList.contains('show')) {
        navbarElement.classList.remove('show');
        navbarToggler.classList.add('collapsed');
        navbarToggler.ariaExpanded = false;
      }
    });
  }
});
